export const PRODUCT_RESPONSE_FROM_HANDLE = `query Product($handle: String!) {
  product(handle: $handle) {
    handle
  }
}`;

export const UPSELL_ITEM = `query Product($handle: String!) {
  product(handle: $handle) {
    title
    tags
    handle
    id
    onlineStoreUrl
    options {
      name
      values
    }
    variants(first: 100) {
      edges {
        node {
          ...variant
        }
      }
    }
    shortDescription: metafield(namespace: "acf_pdp", key: "description_short") {
      value
    }
    fromPrice: metafield(namespace: "acf_pdp", key: "from_price") {
      value
    }
  }
}
fragment variant on ProductVariant {
  id
  sku
  price {
    amount
  }
  compareAtPrice {
    amount
  }
  quantityAvailable
  image {
    url(
      transform: { maxWidth: 128, crop: CENTER }
    )
    altText
  }
  selectedOptions {
    name
    value
  }
  shipsBy: metafield(namespace: "acf_variant", key: "ships_by") {
    value
  }
}`;
